module.exports = __webpack_public_path__ + "img/cat-02-in.d917f134.svg";